import { render } from "./index.vue?vue&type=template&id=fad4462c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=fad4462c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad4462c"],['__file',"src/views/MyAccount/MyBooking/ReviewBooking/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fad4462c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fad4462c', __exports__)) {
    console.log('reload')
    api.reload('fad4462c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=fad4462c&scoped=true", () => {
    console.log('re-render')
    api.rerender('fad4462c', render)
  })

}


export default __exports__